import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FileEdit, MessageSquare, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { FeedbackDialog } from "./FeedbackDialog";
import { DirectMessageDialog } from "./DirectMessageDialog";
import { getPageName } from "@/utils/pageRouteMapper";

export const FeedbackButton = () => {
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [dmDialogOpen, setDmDialogOpen] = useState(false);
  const location = useLocation();
  
  const pageRoute = location.pathname;
  const pageName = getPageName(pageRoute);

  return (
    <>
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                size="icon"
                className="h-10 w-10 rounded-full bg-green-700 hover:bg-green-800 text-white"
                aria-label="Feedback and messaging options"
              >
                <FileEdit className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>Feedback & Messages</p>
          </TooltipContent>
        </Tooltip>
        
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem onClick={() => setFeedbackDialogOpen(true)}>
            <MessageSquare className="mr-2 h-4 w-4" />
            <span>Give feedback to iSPAI</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setDmDialogOpen(true)}>
            <Send className="mr-2 h-4 w-4" />
            <span>Direct Message</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <FeedbackDialog
        open={feedbackDialogOpen}
        onOpenChange={setFeedbackDialogOpen}
        pageRoute={pageRoute}
        pageName={pageName}
      />

      <DirectMessageDialog
        open={dmDialogOpen}
        onOpenChange={setDmDialogOpen}
      />
    </>
  );
};
